import { useRecoilValue } from "recoil";

import { AuthScreenAtom, Authorization } from "../../state/authAtoms";
import { LoginChoices } from "./LoginChoices";
import LoginWithEmail from "./LoginWithEmail";

function Login() {
  const screen = useRecoilValue(AuthScreenAtom);
  const auth = useRecoilValue(Authorization);

  if (auth.isLoggedIn) {
    return <></>;
  }

  if (screen === "loginEmail") {
    return <LoginWithEmail />;
  }

  return <LoginChoices />;
}

export default Login;
